const EnumRole = {
  GENERAL: "general_tab",
  TECH_STAT: "technical_statistics_tab",
  SALES: "sales_tab",
  ISSUES: "issues_tab",
  FNS: "fns_tab",
  ACC_REC: "account_receivable_tab"
};

export default EnumRole;
